import { css } from "@emotion/css";

export const iconButtonStyles = {
  container: css({
    cursor: 'pointer',
    'svg': {
      height: '100%',
      width: '100%',
    }
  })
}